/* eslint semi:0 */
import { urlWithQs, m } from '../../utils/mithril'
import {
  get as getFromPdo,
  getSiteDomainWithTld,
  getPostUrl,
  getPostTitle,
} from '../../application/pageDataObject'
import { openEmbed } from '../actions/socialButtonsActions'
import { t, locale } from '../../providers/i18nProvider/i18nProvider'

export const FACEBOOK = 'facebook'
export const TWITTER = 'twitter'
export const MESSAGE = 'message'
export const WHATSAPP = 'whatsapp'
export const EMBED = 'embed'
export const COMMENTS = 'comments'
export const REDDIT = 'reddit'

const EMBED_CODE_FEATURE_ID = 'EmbedCode'

const ANALYTICS_ACTION_SHARE = 'article share click'
const ANALYTICS_ACTION_EMBEDED = 'article embed click'

const TWITTER_VIA = {
  '90min.com': {
    default: '90min_Football',
  },
  'ftb90.com': {
    default: 'ftb_90',
  },
  '12up.com': {
    default: '12upSport',
    es: '12up_ES',
  },
  'minutemediaalpha.com': {
    default: 'Esp_Interativo',
  },
  'floor8.com': {
    default: 'Floor8Official',
    es: 'Floor8_ES',
  },
}

function twitterVia() {
  const forDomain = TWITTER_VIA[getSiteDomainWithTld()]
  return forDomain && (forDomain[locale] || forDomain.default)
}

export const SOCIAL_BUTTONS_CONF = {
  [FACEBOOK]: {
    title: 'Facebook',
    name: FACEBOOK,
    get href() {
      const sharedUrlParams = {
        utm_source: this.sourceName, // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const urlParams = {
        u: urlWithQs(getPostUrl(), sharedUrlParams),
      }
      return urlWithQs('https://www.facebook.com/sharer.php', urlParams)
    },
    sourceName: 'facebook.com',
    analyticsActionText: ANALYTICS_ACTION_SHARE,
  },
  [TWITTER]: {
    title: t('common.tweet'),
    name: TWITTER,
    get href() {
      const sharedUrlParams = {
        utm_source: this.sourceName, // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const urlParams = {
        text: getPostTitle().replace('|', '-'),
        via: twitterVia(),
        url: urlWithQs(getPostUrl(), sharedUrlParams),
      }
      return urlWithQs('https://twitter.com/share', urlParams)
    },
    sourceName: 'twitter.com',
    analyticsActionText: ANALYTICS_ACTION_SHARE,
  },
  [WHATSAPP]: {
    title: t('common.share'),
    name: WHATSAPP,
    sourceName: 'whatsapp',
    get href() {
      const sharedUrlParams = {
        utm_source: this.sourceName, // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const postUrl = urlWithQs(getPostUrl(), sharedUrlParams)
      return ['whatsapp://send?text=', getPostTitle(), encodeURIComponent(`: ${postUrl}`)].join('')
    },
    analyticsActionText: ANALYTICS_ACTION_SHARE,
  },
  [REDDIT]: {
    featureId: 'REDDIT',
    title: 'Reddit',
    name: REDDIT,
    get href() {
      const sharedUrlParams = {
        utm_source: this.sourceName, // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const urlParams = {
        title: getPostTitle().replace('|', '-'),
        url: urlWithQs(getPostUrl(), sharedUrlParams),
        kind: 'link',
      }
      return urlWithQs('https://reddit.com/submit', urlParams)
    },
    sourceName: 'reddit.com',
    analyticsActionText: ANALYTICS_ACTION_SHARE,
  },
  [EMBED]: {
    featureId: EMBED_CODE_FEATURE_ID,
    title: t('embed.button'),
    name: EMBED,
    onClick: openEmbed,
    analyticsActionText: ANALYTICS_ACTION_EMBEDED,
  },
}

export default SOCIAL_BUTTONS_CONF



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/socialButtonsConfig.js